enum ViewerEvent {
  TTS_STATUS = "tts:status",
  BOOK_PAGEBREAK = "book:pagebreak",
  SELECTION_MADE = "book:selectionMade",
  KEYUP = "keyup",
  SELECTION_CANCELLED = "book:selectionCancelled",
  HIGHLIGHT_CLICK_OUTSIDE = "highlight:clickOutside",
  HIGHLIGHT_CLICK = "highlight:contentClick",
  NAVIGATION_REQUESTED = "book:navigationRequested",
  PAGE_SCROLL = "page:scroll",
  PAGE_READY = "page:ready",
  PAGE_ERROR = "page:error",
  PAGE_LOAD_SCROLL = "page:loadScroll",
  LOCATION_UPDATE = "location:update",
  IMAGE_TOOL_ZOOM = "image-tools:zoom",
  IMAGE_TOOL_FLASHCARD = "image-tools:flashcard",
  IMAGE_TOOL_CLICK_OUTSIDE = "image-tools:clickOutside",
  CLICK = "click",
  SNIPPET_NAV_BLOCKED = "snippet:navigationBlocked",
  USER_SIGNOUT = "user:signout",
}

export default ViewerEvent;
